import SimpleBar from "simplebar";
import "featherlight";
import "featherlight/src/featherlight.gallery";
//import Litepicker from 'litepicker'
//import 'litepicker/dist/plugins/multiselect'
import noUiSlider from "nouislider";
import smoothscroll from "smoothscroll-polyfill";
import carousel from "vue-owl-carousel";

// TODO clean this up more

window.axios = require("axios");
axios.defaults.withCredentials = true;

let $ = require("jquery");
window.$ = $;
window.dayjs = require("dayjs");

require("./vue");

// Deal with Safari being a bit crap
smoothscroll.polyfill();

/**
 * Scroll our window to a target element, offsetting by our persistent header height.
 *
 * @param Element target
 */
window.scrollToTarget = function (target) {
    let header = document.getElementById("header");
    window.scrollTo({
        top:
            target.getBoundingClientRect().top +
            window.pageYOffset -
            header.offsetHeight,
        behavior: "smooth",
    });
};

// Range sliders
$("[data-slider]").each((idx, element) => {
    var $element = $(element);
    var $label_min = $($element.attr("data-slider-label-min"));
    var $label_max = $($element.attr("data-slider-label-max"));
    var min = parseInt($element.attr("data-slider-range-min"));
    var max = parseInt($element.attr("data-slider-range-max"));
    var step = parseInt($element.attr("data-slider-step"));

    noUiSlider.create(element, {
        connect: [false, true, false],
        start: [min, max],
        step: step,
        range: {
            min: [min],
            max: [max],
        },
    });

    element.noUiSlider.on("update", function (values, handle) {
        var min_value = parseInt(values[0]);
        var max_value = parseInt(values[1]);

        switch ($element.attr("data-slider")) {
            case "currency":
                $label_min.text("$" + min_value);
                $label_max.text("$" + max_value);
                break;
            default:
                $label_min.text(min_value);
                $label_max.text(max_value);
                break;
        }
    });
});

// Date pickers
$("[data-date-picker]").each((idx, element) => {
    var picker = new Litepicker(generateLitepickerOptions(element));

    $(window).on("resize", function (e) {
        picker.setOptions(generateLitepickerOptions(element));
    });
});

function generateLitepickerOptions(element) {
    var $el = $(element);
    var options = {
        element: element,
        firstDay: 0,
        disallowLockDaysInRange: true,
    };
    var window_width = $(window).width();

    if ($el.attr("data-date-picker") == "inline") {
        options.inlineMode = true;
    }

    switch ($el.attr("data-date-picker-type")) {
        case "range":
            options.singleMode = false;
            break;
        case "multi":
            options.plugins = ["multiselect"];
            break;
    }

    if ($el.attr("data-date-picker-months")) {
        options.numberOfMonths =
            window_width >= 768
                ? parseInt($el.attr("data-date-picker-months"))
                : 1;
        options.numberOfColumns = options.numberOfMonths;
    }

    if ($el.attr("data-date-picker-min")) {
        options.minDate = $el.attr("data-date-picker-min");
    }

    if ($el.attr("data-date-picker-disable")) {
        options.lockDays = $el.attr("data-date-picker-disable").split(",");
    }

    return options;
}

// Toggly things
$(window).on("click", function (e) {
    var $target = $(e.target);

    if ($.contains($("html")[0], e.target)) {
        $("[data-clickout-toggle]").each(function (idx, clickout) {
            var $clickout = $(clickout);
            var $toToggle = $($clickout.attr("data-clickout-toggle"));
            var class_to_toggle = $clickout.attr("data-clickout-remove");

            if (
                !$.contains(clickout, e.target) &&
                $toToggle.hasClass(class_to_toggle)
            ) {
                $toToggle.removeClass(class_to_toggle);
            }
        });
    }
});

$("[data-toggle-target][data-toggle-class]").on("click", function (e) {
    var $this = $(this);
    e.stopPropagation();

    setTimeout(() => {
        var target_selector = $this.attr("data-toggle-target");
        var toggle_class = $this.attr("data-toggle-class");

        switch (target_selector) {
            case "self":
                $this.toggleClass(toggle_class);
                break;
            case "parent":
                $this.parent().toggleClass(toggle_class);
                break;
            default:
                $(target_selector).toggleClass(toggle_class);
                break;
        }
    }, 10);
});

$("[data-toggle-tab]").on("click", function (e) {
    var $this = $(this);
    e.stopPropagation();

    $($this.attr("data-toggle-tab")).trigger("click");
});

$("[data-prevent-bubble]").each(function () {
    var $this = $(this);

    $this.on($this.attr("data-prevent-bubble"), function (e) {
        e.stopPropagation();
    });
});

// Account subpages...
$("[data-toggle-subpage]").each((idx, trigger) => {
    var $trigger = $(trigger);
    var $group = $trigger.closest(".has-subpages");

    $trigger.on("click", function (e) {
        setTimeout(() => {
            $group.children(".account-subpage").removeClass("active");
            $group
                .find($trigger.attr("data-toggle-subpage"))
                .addClass("active");
        }, 50);
    });
});

// Tagging mockup
$("[data-tag-listing]").each((idx, label) => {
    var $label = $(label);
    var $group = $label.closest(".form-group");
    var $listing = $($label.attr("data-tag-listing"));

    $listing.on("click", function (e) {
        setTimeout(() => {
            var selected = [];

            $listing.find(".selected").each((idx, tag) => {
                selected.push($(tag).text());
            });

            if (selected.length) {
                $group.addClass("populated");
                $label.text(selected.join(", "));
            } else {
                $group.removeClass("populated");
                $label.text($label.attr("data-tag-listing-label"));
            }
        }, 50);
    });
});

// Placeholder, floatup etc fields
$(".form-group input, .form-group [contenteditable]").on("focus", function (e) {
    var $group = $(this).closest(".form-group");
    $group.addClass("focused");
});

$(".form-group input, .form-group select, .form-group [contenteditable]").on(
    "input change",
    function (e) {
        var $this = $(this);
        var $group = $this.closest(".form-group");

        if ($this.is("[contenteditable]")) {
            if ($this.text().replace(/^\s+|\s+$/).length) {
                $group.addClass("populated");
            } else {
                $group.removeClass("populated");
            }
        } else {
            if ($this.val()) {
                $group.addClass("populated");
            } else {
                $group.removeClass("populated");
            }
        }
    }
);

$(".form-group input, .form-group [contenteditable]").on("blur", function (e) {
    var $group = $(this).closest(".form-group");
    $group.removeClass("focused");
});

// Initial state
$(".form-group input").trigger("input");
$(".form-group select").trigger("change");

// Redo selector on resize
import _throttle from "lodash/throttle";

$(window).on(
    "resize",
    _throttle(() => {
        $(".tabbed").each((idx, container) => {
            $(container)
                .find(".tabs [data-tab-target].active")
                .trigger("click");
        });
    }, 300)
);

// Video play links
$("[data-play-video]").on("click", function (e) {
    e.preventDefault();
});

// Account pages
$("[data-account-pane]:not(.account-pane)").on("click", function (e) {
    var $this = $(this);
    var $account = $("#account-modal");
    e.stopPropagation();

    $account.attr("data-active-pane", $this.attr("data-account-pane"));
    $account.find(".account-pane[data-account-pane]").removeClass("active");
    $account
        .find(
            '.account-pane[data-account-pane="' +
                $this.attr("data-account-pane") +
                '"]'
        )
        .addClass("active");
});

// Account navigation
var updateAccountNav = function ($container) {
    var $navContainer = $container.find(".account-nav-items");
    var $navItems = $navContainer.find("> li");
    var $selected = $container.find(".selected").first();
    var item_width = $navItems.first().outerWidth();
    var items_per_page = Math.round($navContainer.width() / item_width);
    var pages = Math.ceil($navItems.length / items_per_page);
    var full_pages = Math.floor($navItems.length / items_per_page);
    var max_offset = Math.round(
        (full_pages - 1) * items_per_page + ($navItems.length % items_per_page)
    );
    var from_page = parseInt($container.attr("data-from-page"));
    var current_page = parseInt($container.attr("data-current-page"));

    if (current_page > pages) {
        current_page = pages;
    } else if (current_page < 1) {
        current_page = 1;
    }

    // Update current page?
    $container.attr("data-current-page", current_page);

    // Show/hide pagination as needed
    var can_nav_prev = current_page > 1;
    var can_nav_next = current_page < pages;
    $container.toggleClass("can-nav-prev", can_nav_prev);
    $container.find('[data-page-to="prev"]').attr("disabled", !can_nav_prev);
    $container.toggleClass("can-nav-next", can_nav_next);
    $container.find('[data-page-to="next"]').attr("disabled", !can_nav_next);

    // Work out which item to start showing with
    var offset = Math.min((current_page - 1) * items_per_page, max_offset);
    $navItems
        .first()
        .css({ marginLeft: offset * (-100 / items_per_page) + "%" });
    $navItems.removeClass("visible");

    for (var x = 0; x < items_per_page; x++) {
        $navItems.eq(x + offset).addClass("visible");
    }
};

// Pagination events
$(".account-nav")
    .find("[data-page-to]")
    .on("click", function (e) {
        var $this = $(this);
        var $target = $($this.attr("data-page-target"));
        var target_page = $this.attr("data-page-to");
        $target.attr("data-from-page", $target.attr("data-current-page"));
        e.stopPropagation();

        if ($target[0]) {
            switch (target_page) {
                case "prev":
                    $target.attr(
                        "data-current-page",
                        parseInt($target.attr("data-current-page")) - 1
                    );
                    break;
                case "next":
                    $target.attr(
                        "data-current-page",
                        parseInt($target.attr("data-current-page")) + 1
                    );
                    break;
            }

            updateAccountNav($target);
        }
    });

// Accordions
$(".accordion, .accordion-like").each(function (idx, container) {
    var $container = $(container);

    $container.find(".toggler").on("click", function (e) {
        var $this = $(this);
        var $element = $this.closest(".accordion-element");
        var toggle_to = $element.hasClass("active");
        e.stopPropagation();

        if ($container.is(".accordion-like")) {
            $container.toggleClass("active");
        } else {
            $container.find(".accordion-element").removeClass("active");
            $element.toggleClass("active", !toggle_to);
        }
    });
});

// Carousels
var updateCarousel = function ($container) {
    var $carousel = $container.find(".carousel");
    var $carouselItems = $carousel.find("> li");
    var item_width = $carouselItems.first().outerWidth();
    var items_per_page = Math.round($carousel.width() / item_width);
    var pages = Math.ceil($carouselItems.length / items_per_page);
    var full_pages = Math.floor($carouselItems.length / items_per_page);
    var max_offset = Math.round(
        (full_pages - 1) * items_per_page +
            ($carouselItems.length % items_per_page)
    );
    var current_page = parseInt($container.attr("data-current-page"));

    if (current_page > pages) {
        current_page = pages;
    } else if (current_page < 1) {
        current_page = 1;
    }

    // Update current page?
    $container.attr("data-current-page", current_page);

    // Show/hide pagination as needed
    var can_nav_prev = current_page > 1;
    var can_nav_next = current_page < pages;
    $carousel.toggleClass("can-nav-prev", can_nav_prev);
    $container
        .find('[data-carousel-page="prev"]')
        .attr("disabled", !can_nav_prev);
    $carousel.toggleClass("can-nav-next", can_nav_next);
    $container
        .find('[data-carousel-page="next"]')
        .attr("disabled", !can_nav_next);

    // Work out which item to start showing with
    var offset = Math.min((current_page - 1) * items_per_page, max_offset);
    $carouselItems
        .first()
        .css({ marginLeft: offset * (-100 / items_per_page) + "%" });
    $carouselItems.removeClass("visible");

    for (var x = 0; x < items_per_page; x++) {
        $carouselItems.eq(x + offset).addClass("visible");
    }
};

// Init carousels
$(".carousel-container").each((idx, carousel) => {
    var $container = $(carousel);
    $container.attr("data-current-page", 1);

    // Pagination events
    $container.find("[data-carousel-page]").on("click", function (e) {
        var $this = $(this);
        var $target = $($this.attr("data-carousel-target"));
        var target_page = $this.attr("data-carousel-page");
        e.stopPropagation();

        if ($target[0]) {
            switch (target_page) {
                case "prev":
                    $target.attr(
                        "data-current-page",
                        parseInt($target.attr("data-current-page")) - 1
                    );
                    break;
                case "next":
                    $target.attr(
                        "data-current-page",
                        parseInt($target.attr("data-current-page")) + 1
                    );
                    break;
            }

            updateCarousel($target);
        }
    });

    if ($container.attr("data-autorotate-interval")) {
      setInterval(function () {
        if ($container.find("[data-carousel-page='next']").attr("disabled") !== "disabled") {
          $container.find("[data-carousel-page='next']").click();
        } else {
          var $carousel = $container.find(".carousel");
          var $carouselItems = $carousel.find("> li");
          var item_width = $carouselItems.first().outerWidth();
          var items_per_page = Math.round($carousel.width() / item_width);
          var pages = Math.ceil($carouselItems.length / items_per_page);
          for (var x = 0; x < pages; x++) {
            $container.find("[data-carousel-page='prev']").click();
          }
        }
      }, $container.attr("data-autorotate-interval"));
    }

    $(window).on("resize", function (e) {
        updateCarousel($container);
    });

    // Do initial carousel setup
    updateCarousel($container);
});

// And we're initialized
setTimeout(() => {
    $("body").addClass("initialized");
}, 100);

$(document).ready(function () {
    setSlider();
    setupStickyHeader();
    fadeOutHero();
});

function setupStickyHeader() {
    const header = document.getElementById("header");
    const documentBody = document.body;
    document.addEventListener("scroll", function () {
        if (window.scrollY > header.offsetHeight) {
            header.classList.add("scrolled");
            documentBody.classList.add("scrolled");
            if (documentBody.classList.contains("transparent")) {
                documentBody.classList.remove("header--transparent");
            }
        }
        if (window.scrollY === 0) {
            header.classList.remove("scrolled");
            documentBody.classList.remove("scrolled");
            if (documentBody.classList.contains("transparent")) {
                document.body.classList.add("header--transparent");
            }
        }
    });
}

function setSlider() {
    $(".slider").each(function () {
        var $slider = $(this),
            $itemscontainer = $slider.find(".slider-items-container");

        if ($itemscontainer.find(".slider-item.active").length == 0) {
            $itemscontainer.find(".slider-item").first().addClass("active");
        }

        function setWidth() {
            var totalWidth = 0;

            $($itemscontainer)
                .find(".slider-item")
                .each(function () {
                    totalWidth += $(this).outerWidth();
                });

            $itemscontainer.width(totalWidth);
        }
        function setTransform() {
            var $activeItem = $itemscontainer.find(".slider-item.active"),
                activeItemOffset = $activeItem.offset().left,
                itemsContainerOffset = $itemscontainer.offset().left,
                totalOffset = activeItemOffset - itemsContainerOffset;

            $itemscontainer.css({
                transform: "translate( -" + totalOffset + "px, 0px)",
            });
        }
        function nextSlide() {
            var activeItem = $itemscontainer.find(".slider-item.active"),
                activeItemIndex = activeItem.index(),
                sliderItemTotal = $itemscontainer.find(".slider-item").length,
                nextSlide = 0;

            if (activeItemIndex + 1 > sliderItemTotal - 1) {
                nextSlide = 0;
            } else {
                nextSlide = activeItemIndex + 1;
            }

            var nextSlideSelect = $itemscontainer
                    .find(".slider-item")
                    .eq(nextSlide),
                itemContainerOffset = $itemscontainer.offset().left,
                totalOffset =
                    nextSlideSelect.offset().left - itemContainerOffset;

            $itemscontainer.find(".slider-item.active").removeClass("active");
            nextSlideSelect.addClass("active");
            $slider.find(".dots").find(".dot").removeClass("active");
            $slider.find(".dots").find(".dot").eq(nextSlide).addClass("active");
            $itemscontainer.css({
                transform: "translate( -" + totalOffset + "px, 0px)",
            });
        }
        function prevSlide() {
            var activeItem = $itemscontainer.find(".slider-item.active"),
                activeItemIndex = activeItem.index(),
                sliderItemTotal = $itemscontainer.find(".slider-item").length,
                nextSlide = 0;

            if (activeItemIndex - 1 < 0) {
                nextSlide = sliderItemTotal - 1;
            } else {
                nextSlide = activeItemIndex - 1;
            }

            var nextSlideSelect = $itemscontainer
                    .find(".slider-item")
                    .eq(nextSlide),
                itemContainerOffset = $itemscontainer.offset().left,
                totalOffset =
                    nextSlideSelect.offset().left - itemContainerOffset;

            $itemscontainer.find(".slider-item.active").removeClass("active");
            nextSlideSelect.addClass("active");
            $slider.find(".dots").find(".dot").removeClass("active");
            $slider.find(".dots").find(".dot").eq(nextSlide).addClass("active");
            $itemscontainer.css({
                transform: "translate( -" + totalOffset + "px, 0px)",
            });
        }
        function makeDots() {
            var activeItem = $itemscontainer.find(".slider-item.active"),
                activeItemIndex = activeItem.index(),
                sliderItemTotal = $itemscontainer.find(".slider-item").length;

            for (let i = 0; i < sliderItemTotal; i++) {
                $slider.find(".dots").append("<div class='dot'></div>");
            }

            $slider
                .find(".dots")
                .find(".dot")
                .eq(activeItemIndex)
                .addClass("active");
        }

        setWidth();
        setTransform();
        makeDots();

        $(window).resize(function () {
            setWidth();
            setTransform();
        });

        var nextBtn = $slider.find(".controls").find(".next-btn"),
            prevBtn = $slider.find(".controls").find(".prev-btn");

        function do_slide() {
            var interval = setInterval(function () {
                nextSlide();
            }, 7000);
        }

        do_slide();

        nextBtn.on("click", function (e) {
            e.preventDefault();
            nextSlide();
        });

        prevBtn.on("click", function (e) {
            e.preventDefault();
            prevSlide();
        });

        $slider
            .find(".dots")
            .find(".dot")
            .on("click", function (e) {
                var dotIndex = $(this).index(),
                    totalOffset =
                        $itemscontainer
                            .find(".slider-item")
                            .eq(dotIndex)
                            .offset().left - $itemscontainer.offset().left;

                $itemscontainer
                    .find(".slider-item.active")
                    .removeClass("active");
                $itemscontainer
                    .find(".slider-item")
                    .eq(dotIndex)
                    .addClass("active");
                $slider.find(".dots").find(".dot").removeClass("active");
                $(this).addClass("active");

                $itemscontainer.css({
                    transform: "translate( -" + totalOffset + "px, 0px)",
                });
            });
    });
}

function fadeOutHero() {
    var heroContent = $("#search-feature");
    $("#explore-spaces-menu").hover(
        function () {
            heroContent.addClass("fade-out");
        },
        function () {
            heroContent.removeClass("fade-out");
        }
    );
}

$(".instagram-feed-container .btn-more-less").on("click", function (e) {
    $(".instagram-feed-container .post.toggleable").toggle();
    $(".instagram-feed-container .post.toggleable img").each(function() {
        $(this).attr("src", $(this).data("src"));
    })
    $(this).html($(this).html() == 'Show More' ? 'Show Less' : 'Show More');
});
